export default "__VITE_ASSET__v8UEccL9__"